export default __webpack_public_path__ + "static/media/MarketRealCase1-moblie.297ad19a.jpg";